import ImagesAuthenticationVerifyEmailTwoFriendsDrinkingWhiskyBeachSunsetWebp from '@/public/images/authentication/verify-email/two-friends-drinking-whisky-beach-sunset.webp';

export { ImagesAuthenticationVerifyEmailTwoFriendsDrinkingWhiskyBeachSunsetWebp };
